import React from 'react';
import { RecipeText, SEORecipe } from '../components';

export default function ChockMed() {
  const breadcrumbs = [
    {
      to: '/#reccats',
      title: 'Категории рецептов'
    },
    {
      to: '/bakery',
      title: 'Выпечка'
    }
  ];

  const recipe = {
    title: 'Шоколадный медовик',
    imgSrc: '/chockmed.jpg',
    ingredients: [
      {
        header: 'ДЛЯ 10 КОРЖЕЙ Д 17–18 СМ:',
        list: ["300 г сахара", "3 яйца С0", "60 г меда", "100 г сливочного масла 82,5%", "10 г пищевой соды", "500 г пшеничной муки", "100 г какао-порошка"]
      },
      {
        header: 'ДЛЯ КРЕМА:',
        list: ["1,2 кг сметаны 20–25%", "200 г сахара", "50 г какао-порошка", "200 г сливочного масла 82,5%", "Ягоды и шоколад для украшения"]
      }
    ],
    bookSrc: `Рецепт из книги Олеси Куприн <a target="_blank" rel="noopener noreferrer" href="https://www.litres.ru/olesya-kuprin/shokoladnaya-kniga-48505300/">«Шоколадная книга»</a>`,
    steps: [
      {
        list: [
          'Торт начинается с подготовки крема. Вам понадобится марля и дуршлаг или тонкое полотенце. Выстелите дуршлаг марлей и поставьте его на глубокую миску, поверх марли выложите сметану. Оставьте сметану на ночь стекать. У меня не было марли, я взяла тонкое хлопковое полотенце, переложила в него сметану, собрала края полотенца так, чтобы получился узелок. Перемотала его концы веревкой и подвесила над миской, на ручке кухонного шкафа, на ночь.',
          'Утром сметану переложите в кастрюлю с толстым дном, к этому моменту сметана должна стать плотной и довольно сухой. Добавьте к ней сахар и какао, хорошо перемешайте и варите смесь на медленном огне, постоянно помешивая, до полного растворения сахара. Затем снимите с огня.',
          'Сливочное масло комнатной температуры нарежьте кубиками и добавьте в смесь. Перемешайте до однородности. Затем уберите получившийся крем в холодильник до полного застывания. Крем должен стать плотным и держать форму. Точное время застывания крема зависит от уровня нагрева сметаны и качества сливочного масла. Большое значение имеет температура в холодильнике. В среднем крему требуется 2–3 часа – за это время вы как раз подготовите, испечете и охладите коржи. Сметана и сливочное масло должны быть самыми лучшими из доступных. Не выбирайте продукты с меньшим процентом жирности, чем это указано в рецепте.',
          'Для теста в жаростойкой миске смешайте яйца, сахар, масло и мед. Поставьте миску на водяную баню. Постоянно помешивая, нагревайте смесь до полного растворения сахара. Масса должна стать однородной, но не должна загустеть. Снимите с огня, добавьте соду и интенсивно перемешайте.',
          'Муку перемешайте с какао, всыпьте смесь в жидкую часть и хорошо размешайте тесто. Вымешивайте, пока тесто не станет мягким и эластичным и перестанет липнуть к рукам.',
          'Разделите тесто на 10 частей. Каждую часть тонко раскатайте и выпекайте по очереди при 200°С в течение 3–5 минут до готовности, ориентируйтесь по своей плите. Как только один корж испекся, переложите его на стол и сразу же вырезайте круг нужного диаметра (коржи быстро затвердевают, поэтому вырезать нужно сразу, как вынули из духовки).',
          'Обрезки коржей измельчите в блендере, они нам понадобятся, чтобы сделать крошки, которыми будем обсыпать торт.',
          'Когда все составляющие готовы, приступайте к сборке торта. Крем достаньте из холодильника, если он слишком уплотнился, просто перемешайте его лопаткой. Промажьте коржи кремом и сложите один на другой. Верхний корж тоже необходимо покрыть кремом, как и бока торта.',
          'Верх и бока торта обсыпьте молотыми обрезками коржей. Уберите торт на ночь в холодильник, чтобы он настоялся. готовый торт украсьте шоколадными плитками или ягодами. Я просто растопила 150 г шоколада на водяной бане, залила его в силиконовые формочки и полученными медалями украсила торт.'
        ]
      },
    ],
    note: [
      'Количество муки и какао в тесте зависит от того, насколько сильно разогрета смесь для теста. Чем она горячее, тем больше мучной смеси потребуется. Я рекомендую всыпать перемешанные муку и какао порциями.',
      'Корж можно вынимать из духовки, как только он подрумянился, но будьте осторожны, горячие коржи очень мягкие и хрупкие. Корж полностью стабилизируется уже на столе, при остывании.'
    ],
    thisUrl: 'chockmed'
  };
  return(
    <>
      <SEORecipe recipe={recipe} />
      <RecipeText page='bakery' recipe={recipe} breadcrumbs={breadcrumbs} />
    </>
  );
}
